import { useEffect } from 'react';

/**
 * Hook to prevent Back-Forward Cache (BFCache) behavior
 * Particularly useful for Safari iOS
 */
var useBFCacheBuster = function useBFCacheBuster() {
  useEffect(function () {
    // Reload if page restored from BFCache
    var handlePageShow = function handlePageShow(event) {
      if (event.persisted) {
        console.log('[BFCache Buster][2] Page restored from BFCache, reloading...');
        window.location.reload();
      }
    };

    // Reload on back button navigation
    var handlePopState = function handlePopState() {
      console.log('[BFCache Buster][1] Back button pressed, reloading...');
      window.location.reload();
    };

    // Prevent BFCache eligibility
    var handleBeforeUnload = function handleBeforeUnload() {};
    window.addEventListener('pageshow', handlePageShow);
    window.addEventListener('popstate', handlePopState);
    window.addEventListener('beforeunload', handleBeforeUnload);
    return function () {
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
};
export default useBFCacheBuster;